/**
 * array of widget names that are removed from code but might be returned from the layout
 * we need this list so we won't try and render these widgets that actually don't exist anymore
 */
export const depricatedWidgets = [
  'negotiate-widget'
];